<template>
  <v-container grid-list-lg fluid>
    <v-layout row wrap>
      <v-flex xs12 class="pa-4">
        <v-layout row wrap>
          <v-flex xs12 md3>
            <label class="toggle-label">
              Detener gestión al entablar conversación.
            </label>
            <div class="mt-2">
              <toggle-button :value="true"
                :sync="true"
                :width="100"
                :height="30"
                :color="{ checked: '#75c791', unchecked: '#ff6e6e' }"
                :labels="{checked: 'Si', unchecked: 'No'}"
                v-model="form.config.stopManagement"
                :disabled="ajaxOn"
                @input="$emit('holi')"/>
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <label class="toggle-label">
              Asignar chat al asesor del cliente
            </label>
            <div class="mt-2">
              <toggle-button :value="true"
                :sync="true"
                :width="100"
                :height="30"
                :color="{ checked: '#75c791', unchecked: '#ff6e6e' }"
                :labels="{checked: 'Si', unchecked: 'No'}"
                v-model="form.config.assignment"
                :disabled="ajaxOn"
                @input="$emit('holi')"/>
            </div>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.name"
              min="0"
              :label="labelCategory"
              hint="Categoria a asignar cuando se cierre un chat automaticamente."
              persistent-hint
              :disabled="form.close_category_id > 0"
              color="black"
              v-validate="'max:191'"
              data-vv-name="name"
              :data-vv-as="labelCategory"
              :error-messages="errors.collect('name')">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.close"
              v-validate="'max:191'"
              data-vv-name="close"
              type="number"
              min="0"
              data-vv-as="días para cerrar un chat no resuelto"
              :error-messages="errors.collect('close')"
              label="Días para cerrar un chat no resuelto"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6>
            <v-text-field
              v-model="form.agent_limit"
              v-validate="'max:191'"
              data-vv-name="agent_limit"
              type="number"
              min="0"
              data-vv-as="número maximo de chats que puede tener un agente"
              :error-messages="errors.collect('agent_limit')"
              label="Número maximo de chats que puede tener un agente"
              color="black">
            </v-text-field>
          </v-flex>
          <v-flex xs12 md6 v-if="canSeeMaxSmsCharConfig">
            <v-select
              v-model="form.config.max_sms_char"
              :items="smsMaxChar"
              item-value="value"
              item-text="label"
              label="Máximo caracteres para SMS"
              color="black"
              autocomplete>
            </v-select>
          </v-flex>
        </v-layout>

        <!-- Cierre programado: mismo apartado, solo con release schedule_close_chat_center -->
        <v-layout row wrap v-if="scheduleCloseReleaseActive" class="mt-4">
          <v-flex xs12>
            <h3 class="subheading mb-1">
              Cierre programado
            </h3>
            <p class="caption grey--text mb-3">
              Cierra chats WhatsApp en horario fijo. Independiente del cierre por días de inactividad.
            </p>
          </v-flex>
          <v-flex xs12 md3>
            <label class="toggle-label">
              Activar cierre programado
            </label>
            <div class="mt-2">
              <toggle-button
                :sync="true"
                :width="100"
                :height="30"
                :color="{ checked: '#75c791', unchecked: '#ff6e6e' }"
                :labels="{checked: 'Si', unchecked: 'No'}"
                v-model="scheduleForm.enabled"
                :disabled="scheduleAjaxOn"/>
            </div>
          </v-flex>
          <v-flex xs12 md3>
            <v-select
              v-model="scheduleForm.frequency"
              :items="frequencyOptions"
              item-value="value"
              item-text="text"
              label="Frecuencia"
              color="black"
              :hint="scheduleFrequencyLegend"
              persistent-hint
              :disabled="scheduleAjaxOn">
            </v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-select
              v-model="scheduleForm.hour"
              :items="hourOptions"
              label="Hora"
              color="black"
              hint="Hora de la empresa"
              persistent-hint
              :disabled="scheduleAjaxOn">
            </v-select>
          </v-flex>
          <v-flex xs12 md3>
            <v-select
              v-model="scheduleForm.minute"
              :items="minuteOptions"
              label="Minuto"
              color="black"
              :disabled="scheduleAjaxOn">
            </v-select>
          </v-flex>
          <v-flex xs12 v-if="scheduleForm.frequency === 'weekly'" class="mb-2">
            <p class="caption mb-2">
              Días de la semana
            </p>
            <v-btn
              v-for="day in weekDayOptions"
              :key="`schedule-weekday-${day.value}`"
              :class="{'daily-button': true, 'k-orange-linear white--text': scheduleForm.weekdays.includes(day.value)}"
              small
              fab
              flat
              :ripple="false"
              :disabled="scheduleAjaxOn"
              @click="toggleWeekday(day.value)">
              {{ day.text }}
            </v-btn>
            <div
              v-if="scheduleWeekdayError"
              class="error--text caption mt-1">
              {{ scheduleWeekdayError }}
            </div>
          </v-flex>
          <v-flex xs12 md6 v-if="scheduleForm.frequency === 'monthly'">
            <v-select
              v-model="scheduleForm.month_days"
              :items="monthDayOptions"
              label="Días del mes"
              color="black"
              multiple
              chips
              :disabled="scheduleAjaxOn"
              :error-messages="scheduleMonthDayError ? [scheduleMonthDayError] : []">
            </v-select>
          </v-flex>
          <v-flex xs12 md6>
            <v-select
              v-model="scheduleForm.close_category_id"
              :items="closeCategories"
              item-value="id"
              item-text="name"
              label="Categoría de cierre"
              color="black"
              autocomplete
              :disabled="scheduleAjaxOn"
              :error-messages="scheduleCategoryError ? [scheduleCategoryError] : []">
            </v-select>
          </v-flex>
        </v-layout>
        <!-- <v-layout row wrap v-if="false">
            <v-flex xs12>
              <v-text-field
                v-model="form.away_time"
                v-validate="'required|max:191'"
                data-vv-name="away_time"
                type="number"
                min="0"
                data-vv-as="minutos para gestionar la ausencia del cliente"
                :error-messages="errors.collect('away_time')"
                label="Minutos para gestionar la ausencia del cliente"
                color="black">
              </v-text-field>
            </v-flex>
          </v-layout> -->
      </v-flex>
      <v-card-actions class="w-100 px-4 pb-4">
        <v-layout row wrap justify-end>
          <v-btn
            class="k-orange-linear-text"
            flat
            :disabled="isSavingConfig"
            @click="saveConfig">
            GUARDAR
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-layout>
  </v-container>
</template>

<script>
import _ from 'lodash';
import { ToggleButton } from 'vue-js-toggle-button';

const SCHEDULE_CLOSE_RELEASE = 'schedule_close_chat_center';
/** Contrato API (API en paralelo). Alinear si el developer API usa otro path. */
const SCHEDULE_CLOSE_CONFIG_PATH = 'chats_centers/schedule_close_config';

function emptyScheduleForm() {
  return {
    enabled: false,
    frequency: 'daily',
    weekdays: [],
    month_days: [],
    hour: 18,
    minute: 0,
    close_category_id: null,
    inactivity_days: null,
  };
}

export default {
  inject: ['$validator'],
  mounted() {
    this.showConfig();
    this.checkScheduleCloseRelease();
  },
  components: {
    ToggleButton,
  },
  props: {
    tab: {
      type: String,
      default: 'tab-1',
    },
  },
  data() {
    return {
      // Compañías que pueden configurar el máximo de caracteres para SMS (160, 306, 459)
      companyIdsWithMaxSmsCharConfig: [18622237, 86496225],
      ajaxOn: false,
      scheduleAjaxOn: false,
      scheduleCloseReleaseActive: false,
      scheduleWeekdayError: '',
      scheduleMonthDayError: '',
      scheduleCategoryError: '',
      closeCategories: [],
      frequencyOptions: [
        { value: 'daily', text: 'Diario' },
        { value: 'weekly', text: 'Semanal' },
        { value: 'monthly', text: 'Mensual' },
      ],
      weekDayOptions: [
        { text: 'Lu', value: 1 },
        { text: 'Ma', value: 2 },
        { text: 'Mi', value: 3 },
        { text: 'Ju', value: 4 },
        { text: 'Vi', value: 5 },
        { text: 'Sa', value: 6 },
        { text: 'Do', value: 7 },
      ],
      monthDayOptions: Array.from({ length: 31 }, (el, idx) => idx + 1),
      hourOptions: Array.from({ length: 24 }, (el, idx) => idx),
      minuteOptions: Array.from({ length: 60 }, (el, idx) => idx),
      scheduleForm: emptyScheduleForm(),
      smsMaxChar: [
        {
          label: 'Por defecto',
          value: '',
        },
        {
          label: '160',
          value: 160,
        },
        {
          label: '306',
          value: 306,
        },
        {
          label: '459',
          value: 459,
        },
      ],
      form: {
        name: '',
        close: 0,
        away_time: 0,
        agent_limit: 0,
        close_category_id: null,
        config: {
          stopManagement: false,
          assignment: false,
          max_sms_char: 160,
        },
      },
    };
  },
  computed: {
    user() {
      return this.$auth.user();
    },
    canSeeMaxSmsCharConfig() {
      const companyId = parseInt((this.user && this.user.company_id), 10);
      return !Number.isNaN(companyId) && this.companyIdsWithMaxSmsCharConfig.includes(companyId);
    },
    scheduleFrequencyLegend() {
      if (this.scheduleForm.frequency === 'weekly') {
        return 'Se ejecutará los días marcados a esa hora.';
      }
      if (this.scheduleForm.frequency === 'monthly') {
        return 'Se ejecutará solo esos días a esa hora.';
      }
      return 'Se ejecutará cada día a esa hora.';
    },
    isSavingConfig() {
      return this.ajaxOn || this.scheduleAjaxOn;
    },
    labelCategory() {
      return this.form.close_category_id ? 'Categoría' : 'Crear categoría';
    },
    checkCategory() {
      return _.isNil(this.form.close_category_id);
    },
  },
  methods: {
    showConfig() {
      this.axios.get('chats_centers/config').then((response) => {
        if (response.data) {
          const temp = _.pick(response.data, ['close', 'close_category_id', 'agent_limit', 'away_time', 'chat_category.name', 'config']);
          temp.name = (temp.chat_category || {}).name;
          delete temp.chat_category;
          temp.config = temp.config ? {
            ...this.form.config,
            ...JSON.parse(temp.config),
          } : {
            stopManagement: false,
            assignment: false,
          };
          this.form = {
            ...temp,
          };
        }
        this.dialog = true;
      }).catch();
    },
    checkScheduleCloseRelease() {
      this.axios.get('check_release', {
        params: { name: SCHEDULE_CLOSE_RELEASE },
      }).then(({ data }) => {
        this.scheduleCloseReleaseActive = !!(data && data.is_active);
        if (this.scheduleCloseReleaseActive) {
          this.loadCloseCategories();
          this.loadScheduleCloseConfig();
        }
      }).catch(() => {
        this.scheduleCloseReleaseActive = false;
      });
    },
    loadCloseCategories() {
      this.axios.get('chat_categories?paginate=0').then(({ data }) => {
        const list = Array.isArray(data) ? data : (data.data || []);
        this.closeCategories = list.filter(item => item.type === 'movement' || item.type === 'unsolved');
      }).catch(() => {
        this.closeCategories = [];
      });
    },
    loadScheduleCloseConfig() {
      this.axios.get(SCHEDULE_CLOSE_CONFIG_PATH).then(({ data }) => {
        if (!data || (typeof data === 'object' && !Object.keys(data).length)) {
          this.scheduleForm = emptyScheduleForm();
          return;
        }
        this.scheduleForm = {
          ...emptyScheduleForm(),
          enabled: !!data.enabled,
          frequency: data.frequency || 'daily',
          weekdays: Array.isArray(data.weekdays) ? [...data.weekdays] : [],
          month_days: Array.isArray(data.month_days) ? [...data.month_days] : [],
          hour: Number.isInteger(data.hour) ? data.hour : 18,
          minute: Number.isInteger(data.minute) ? data.minute : 0,
          close_category_id: data.close_category_id || null,
          inactivity_days: data.inactivity_days == null ? null : data.inactivity_days,
        };
      }).catch((err) => {
        // 404 / vacío: defaults; otros errores no rompen el apartado legado
        if (err && err.response && err.response.status === 404) {
          this.scheduleForm = emptyScheduleForm();
        }
      });
    },
    toggleWeekday(value) {
      const tmp = [...this.scheduleForm.weekdays];
      const index = tmp.indexOf(value);
      if (index !== -1) {
        tmp.splice(index, 1);
      } else {
        tmp.push(value);
      }
      tmp.sort((a, b) => a - b);
      this.scheduleForm.weekdays = tmp;
      this.scheduleWeekdayError = '';
    },
    validateScheduleForm() {
      this.scheduleWeekdayError = '';
      this.scheduleMonthDayError = '';
      this.scheduleCategoryError = '';
      const form = this.scheduleForm;
      if (form.frequency === 'weekly' && (!form.weekdays || !form.weekdays.length)) {
        this.scheduleWeekdayError = 'Seleccioná al menos un día de la semana.';
        return false;
      }
      if (form.frequency === 'monthly' && (!form.month_days || !form.month_days.length)) {
        this.scheduleMonthDayError = 'Seleccioná al menos un día del mes.';
        return false;
      }
      if (form.hour < 0 || form.hour > 23 || form.minute < 0 || form.minute > 59) {
        return false;
      }
      if (!form.close_category_id) {
        this.scheduleCategoryError = 'Seleccioná una categoría de cierre.';
        return false;
      }
      return true;
    },
    buildSchedulePayload() {
      const form = this.scheduleForm;
      const inactivity = form.inactivity_days;
      return {
        enabled: !!form.enabled,
        frequency: form.frequency,
        weekdays: form.frequency === 'weekly' ? form.weekdays : [],
        month_days: form.frequency === 'monthly' ? form.month_days : [],
        hour: Number(form.hour),
        minute: Number(form.minute),
        close_category_id: Number(form.close_category_id),
        inactivity_days: inactivity == null || inactivity === '' ? null : Number(inactivity),
      };
    },
    getScheduleSaveErrorMessage(err) {
      const data = err && err.response && err.response.data;
      const errors = data && data.errors;
      if (errors && typeof errors === 'object') {
        const messages = Object.keys(errors).reduce((acc, key) => {
          const value = errors[key];
          if (Array.isArray(value)) {
            return acc.concat(value.filter(Boolean));
          }
          if (value) {
            acc.push(value);
          }
          return acc;
        }, []);
        if (messages.length) {
          return messages.join(' ');
        }
      }
      if (data && data.message) {
        return data.message;
      }
      return 'Error al guardar el cierre programado.';
    },
    showSnackbar(msg, color = 'success') {
      this.$emit('update:color', color);
      this.$emit('update:msg', msg);
      this.$emit('update:model', true);
    },
    saveScheduleCloseConfig() {
      if (!this.validateScheduleForm()) {
        return Promise.reject(new Error('schedule_validation'));
      }
      this.scheduleAjaxOn = true;
      return this.axios.put(SCHEDULE_CLOSE_CONFIG_PATH, this.buildSchedulePayload())
        .then(() => {
          this.scheduleAjaxOn = false;
          return this.loadScheduleCloseConfig();
        })
        .catch((err) => {
          this.scheduleAjaxOn = false;
          throw err;
        });
    },
    saveConfig() {
      if (this.isSavingConfig) {
        return;
      }
      this.ajaxOn = true;
      const obj = this.form;
      if (obj.close_category_id > 0) {
        obj.close_category_id = null;
      }
      this.axios.patch('chats_centers/config', obj).then(() => {
        const afterLegacy = () => {
          this.ajaxOn = false;
          this.showSnackbar('Configuración guardada satisfactoriamente.', 'success');
          this.showConfig();
        };
        if (!this.scheduleCloseReleaseActive) {
          afterLegacy();
          return;
        }
        this.saveScheduleCloseConfig().then(() => {
          afterLegacy();
        }).catch((err) => {
          this.ajaxOn = false;
          if (err && err.message === 'schedule_validation') {
            this.showSnackbar('Configuración legado guardada; revisá el cierre programado.', 'error');
            this.showConfig();
            return;
          }
          this.showSnackbar(this.getScheduleSaveErrorMessage(err), 'error');
          this.showConfig();
        });
      }).catch(() => {
        this.ajaxOn = false;
        this.showSnackbar('Error al guardar la configuración.', 'error');
      });
    },
  },
  watch: {
    tab(value) {
      if (value === 'tab-1') {
        this.showConfig();
        if (this.scheduleCloseReleaseActive) {
          this.loadScheduleCloseConfig();
        } else {
          this.checkScheduleCloseRelease();
        }
      }
    },
  },
};
</script>

<style scoped>
  .toggle-label {
    font-size: 12px;
    color: rgba(0,0,0,.54);
  }
  .daily-button {
    margin: 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/chat_center_v2/config/ChatCenterConfig.vue